import { useState, useEffect, useCallback } from 'react';
import {
  getHeadersUnwrapped,
  searchCsaRequest,
  useUserContext,
  IApiCallStatus,
  IError,
} from '../common';
import { ICsaRequestStatus } from '.';
import { fold } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/function';

export const useCsaRequestSearch = ({
  page,
  pageSize,
  sortBy,
  sortDirection,
  searchBy,
  searchP1,
  searchP2,
}: {
  page: number;
  pageSize: number;
  sortBy: string;
  sortDirection: string;
  searchBy: string;
  searchP1: string;
  searchP2: string;
}) => {
  const { user } = useUserContext();
  const [requestStatus, setRequestStatus] = useState<{
    totalElements: number;
    content: ICsaRequestStatus[];
  }>({ totalElements: 0, content: [] });

  const [call, setCall] = useState<IApiCallStatus>();

  useEffect(() => {
    call === null &&
      flow(
        getHeadersUnwrapped,

        searchCsaRequest
      )(user)({
        page,
        pageSize,
        sortBy,
        sortDirection,
        searchBy,
        searchP1,
        searchP2,
      }).then(
        fold<
          IError,
          {
            totalElements: number;
            content: ICsaRequestStatus[];
          },
          void
        >(
          flow(
            e =>
              setRequestStatus({
                totalElements: 0,
                content: [],
              }),
            () => setCall(false)
          ),
          flow(setRequestStatus, () => setCall(true))
        )
      );
  }, [
    user,
    page,
    pageSize,
    sortBy,
    sortDirection,
    searchBy,
    searchP1,
    searchP2,
    call,
  ]);

  const search = useCallback(() => setCall(null), []);

  // too much effort to rewrite search to call the api directly
  return { requestStatus, call, search };
};
